var map = {
	"./Christopher.jpeg": "bfce",
	"./Julie.jpeg": "ad21",
	"./Karim.jpg": "7800",
	"./iceberg.svg": "a41a",
	"./logo.png": "cf05",
	"./teams.png": "441e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";